import {create} from 'zustand';
import {RatingFormDataStore} from './types';

export const useRatingFormDataStore = create<RatingFormDataStore>(set => ({
	ratingFormData: [],
	setRatingFormData: updater =>
		set(state => ({
			ratingFormData: updater(state.ratingFormData),
		})),
	resetRatingFormData: () => set({ratingFormData: []}),
}));
